import { injectGlobal } from 'styled-components';

const fontFamilies = [
    "HeaderFont",
    "BodyFont",
    "FontLight",
    "FontLightItalic",
    "FontThin",
    "FontThinItalic",
    "FontMedium",
    "FontMediumItalic",
    "FontRegular",
    "FontItalic",
    "FontSemiBold",
    "FontSemiBoldItalic",
    "FontBold",
    "FontBoldItalic",
    "FontBlack",
    "FontBlackItalic"
];

const globalStyles = (apiUrl: string = '') => injectGlobal`
	* {
		box-sizing: border-box;
		margin: 0;
        padding: 0;
	}

    /* 
     * Generate @font-face for fonts.
     * To make use of a particular font, upload a font file named e.g. "FontLight.ttf" to application assets,
     * then reference it in styles by font-family name e.g. "FontLight".
     * Fonts not referenced in styles will not be downloaded.
     */
    ${fontFamilies.map(font => `
        @font-face {
            font-family: '${font}';
            src: url('${apiUrl}/${font}.ttf');
            font-display: fallback;
        }
    `)};
`;

export default globalStyles;


// WEBPACK FOOTER //
// ./src/globalStyles.tsx